import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificacaoService } from './notificacao/notificacao.service';
// services

import {MensagemUtil} from './notificacao/mensagemUtil';
/**
 * @abstract
 */
export abstract class BaseService {
private notificacaoService: NotificacaoService;
private msgUtil: MensagemUtil;
/**
 * @param {?} mensagemUtil
 */
constructor(mensagemUtil: MensagemUtil) {
    this.msgUtil = mensagemUtil;
   }
/**
 * @param {?} error
 * @return {?}
 */
public handleErrors(error: any): Observable<any> {

    this.tratarErro(error);
    return error;
  }
/**
 * @param {?} error
 * @return {?}
 */
private tratarErro(error: any) {
    console.log(error.status);

    if (error.status == 404 || error.status == 0) {
      this.msgUtil.erro('Serviço indisponível no momento.', '');
      return;
    }

  }
/**
 * @param {?} error
 * @return {?}
 */
public handleError(error: HttpErrorResponse) {

    if (error.error instanceof Error) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('A Client-side error occurred:', error.error.message);
    } else {
      console.log("Server-side error occured.", error);
      if (error.status >= 200 && error.status <= 299) {
        return Observable.throw(error);
      }

      if (error.status == 404 || error.status == 0) {
        this.msgUtil.erro('Serviço indisponível no momento.', '');
        return Observable.throw(error);
      }

      if (error.status == 500) {
        this.msgUtil.erro(error.message, '');
        return Observable.throw(error);
      }
    }
    // return an ErrorObservable with a user-facing error message
    return Observable.throw(error);
  };
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MensagemUtil, },
];
}

function BaseService_tsickle_Closure_declarations() {
/** @type {?} */
BaseService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BaseService.ctorParameters;
/** @type {?} */
BaseService.prototype.notificacaoService;
/** @type {?} */
BaseService.prototype.msgUtil;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
